<template>
  <div class="page flex-center">
    <p class="font-size-60 font-color-264480 font-bold">404</p>
    <p class="font-size-30 font-color-264480">页面不见了</p>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  .page {
    width: 100%;
    height: 400px;
  }

  .page p:last-child {
    margin-left: 10px;
  }
</style>
